/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { PatientLabOrderItem } from "./PatientLabOrderItem";

export interface LabFeedItem {
  type?: "lab";
  id: string;
  authored_at?: string | null;
  lab: PatientLabOrderItem;
}
